import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Delete from "../../assets/DigitalMarketing/image/deleteConfirmation.svg";
export default function AlertDialog(props) {
  const { message, open, deleteBranches, title } = props;

  const formatButtonText = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            fontSize: "20px",
            fontWeight: 700,
            display: "flex",
            justifyContent: "center",
          }}
        >
          {title ? title : "Delete Confirmation"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ fontSize: "15px", fontWeight: 500 }}
          >
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{ display: "flex", justifyContent: "center", gap: "10px" }}
        >
          <Button
            onClick={() => deleteBranches(false)}
            style={{
              backgroundColor: "#E6E6E6",
              color: "black",
              fontSize: "18px",
              fontWeight: 500,
               textTransform: "none"
            }}
          >
            {formatButtonText("Cancel")}
          </Button>
          <Button
            onClick={() => deleteBranches(true)}
            style={{ backgroundColor: "#F72847", color: "white", textTransform: "none" }}
          >
            <img src={Delete} />
            <span className="ms-2 f-18 fw-500">
              {formatButtonText("Delete")}
            </span>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
